module.exports = __webpack_public_path__ + "images/stickers/check.2825cc373d518d21acb2.png";